import * as React from 'react';
import { experimentalStyled as styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import Calculation from "./Calculation";
import ModalASCVD from "./ModalASCVD";

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


const MainPage = () => {

    const [weight, setWeight] = useState('');
    const [height, setHeight] = useState('');
    const [age, setAge] = useState('');
    const [sBP, setSBP] = useState('');
    const [cholesterol, setCholesterol] = useState('');
    const [hDL, setHDL] = useState('');
    const [tG, setTG] = useState('');
    const [sex, setSex] = useState('');

    const [hypertension, setHypertension] = useState(false);
    const [cigarette, setCigarette] = useState(false);
    const [acvd, setAcvd] = useState(false);
    const [acvdDisable, setAcvdDisable] = useState(false);
    const [pCI, setPCI] = useState(false);
    const [aCS, setACS] = useState(false);
    const [aortic, setAortic] = useState(false);
    // const [mI, setMI] = useState(false);
    const [pAD, setPAD] = useState(false);
    const [stroke, setStroke] = useState(false);
    // const [tIA, setTIA] = useState(false);
    const [diabetes, setDiabetes] = useState(false);
    const [ldlb, setLdlb] = useState(false);
    const [checkDisabledCounter, setCheckDisabledCounter] = useState(0);

    //let checkDisabledCounter=0;

    const checkDisabled = (e) => {
        //const setCheckDisabledCounter=(value)=>checkDisabledCounter=value;
        if (e.target.checked) {
            // if checked
            setCheckDisabledCounter(checkDisabledCounter + 1);
            console.log('checked');
            setAcvd(true);
            setAcvdDisable(true);
            console.log(checkDisabledCounter);
        } else {
            // if unchecked
            console.log(checkDisabledCounter);
            setCheckDisabledCounter(checkDisabledCounter - 1);
            if (checkDisabledCounter === 1) {
                setAcvdDisable(false);
                setAcvd(false);
            }
            console.log(checkDisabledCounter);
            console.log('unchecked');
        }
    }

    const tgColor = () => {
        if (tG === '' || tG == null) {
            return "white";
        }
        else if (parseInt(tG) < 150) {
            return "white";
        }
        else if (parseInt(tG) <= 499) {
            return "green";
        }
        else if (parseInt(tG) < 1000) {
            return "orange";
        }
        else {
            return "red";
        }
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <ModalASCVD />
            <Grid spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} container>
                <Grid item xs={6} sm={4} md={4}>
                    <h3>Demographic data
                    </h3>
                    <Item>
                        <div align="left">
                            <TextField
                                value={weight}
                                onChange={(e) => setWeight(e.target.value.toString())}
                                type={"number"}
                                required
                                label="Weight(Kg)"
                            /></div>
                    </Item>
                    <Item>
                        <div align="left">
                            <TextField
                                value={height}
                                onChange={(e) => setHeight(e.target.value.toString())}
                                type={"number"}
                                required
                                label="Height(cm)"
                            />
                        </div>
                    </Item>
                    <Item>
                        <div align="left">
                            <TextField
                                value={age}
                                onChange={(e) => setAge(e.target.value.toString())}
                                type={"number"}
                                required
                                label="Age"
                            />
                        </div>
                    </Item>
                    <Item>
                        <div align="left">
                            <TextField
                                value={sBP}
                                onChange={(e) => setSBP(e.target.value.toString())}
                                type={"number"}
                                required
                                label="SBP"
                            />
                        </div>
                    </Item>
                    <Item>
                        <div align="left">
                            <TextField
                                value={cholesterol}
                                onChange={(e) => setCholesterol(e.target.value.toString())}
                                type={"number"}
                                required
                                id="Cholesterol"
                                label="Total-Cholesterol"
                            />
                        </div>
                    </Item>
                    <Item>
                        <div align="left">
                            <TextField
                                value={hDL}
                                onChange={(e) => setHDL(e.target.value.toString())}
                                type={"number"}
                                required
                                id="HDL"
                                label="HDL"
                            />
                        </div>
                    </Item>
                    <Item>
                        <div align="left">
                            <TextField
                                style={{ backgroundColor: tgColor() }}
                                value={tG}
                                onChange={(e) => setTG(e.target.value.toString())}
                                type={"number"}
                                required
                                id="TG"
                                label="TG"
                            />
                        </div>
                    </Item>
                    <Item>
                        <div align="left">
                            <FormControl sx={{ minWidth: 225 }}>
                                <InputLabel id="demo-simple-select-autowidth-label">Sex*</InputLabel>
                                <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="sex"
                                    value={sex}
                                    onChange={(e) => setSex(e.target.value.toString())}
                                    autoWidth
                                    label="Sex"
                                    defaultValue="Male"
                                >
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </Item>

                    <Item>
                        <div align="left"><FormControlLabel sx={{ minWidth: 225 }} control={
                            <Checkbox id="hypertension"
                                onChange={(e) => setHypertension(e.target.checked)}
                                value={hypertension}
                                checked={hypertension} />}
                            label="On hypertension medication" /></div>
                    </Item>
                    <Item>
                        <div align="left"><FormControlLabel sx={{ minWidth: 225 }} control={
                            <Checkbox id="Cigarette"
                                onChange={(e) => setCigarette(e.target.checked)}
                                value={cigarette}
                                checked={cigarette} />}
                            label="Cigarette smoker" /></div>
                    </Item>
                </Grid>
                <Grid item xs={6} sm={4} md={4}
                >
                    <h3>statin benefit groups
                    </h3>
                    <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="ACVD"
                                disabled={acvdDisable}
                                onChange={(e) => setAcvd(e.target.checked)}
                                value={acvd}
                                checked={acvd} />}
                                label={<b>clinical ASCVD</b>} /></div>
                    </Item>
                    <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="PCI"
                                onChange={(e) => {
                                    setPCI(e.target.checked);
                                    checkDisabled(e);
                                    console.log(`${e.target.id} checked`)
                                }}
                                value={pCI}
                                checked={pCI}
                            />
                            }
                                label="Coronary or other Arterial Revascularization" /></div>
                    </Item>
                    <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="ACS"
                                onChange={(e) => {
                                    setACS(e.target.checked);
                                    checkDisabled(e);
                                }}
                                value={aCS}
                                checked={aCS}
                            />}
                                label="CAD (CCS, ACS, MI, PCI, CABG)" /></div>
                    </Item>
                    <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="Aortic"
                                onChange={(e) => {
                                    setAortic(e.target.checked);
                                    checkDisabled(e);
                                }}
                                value={aortic}
                                checked={aortic} />}
                                label="Aortic aneurysm" /></div>
                    </Item>
                    {/* <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="MI"
                                onChange={(e) => {
                                    setMI(e.target.checked);
                                    checkDisabled(e);
                                }}
                                value={mI}
                                checked={mI} />}
                                label="History of MI" /></div>
                    </Item> */}
                    <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="PAD"
                                onChange={(e) => {
                                    setPAD(e.target.checked);
                                    checkDisabled(e);
                                }}
                                value={pAD}
                                checked={pAD} />} label="PAD" />
                        </div>
                    </Item>
                    <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="Stroke"
                                onChange={(e) => {
                                    setStroke(e.target.checked);
                                    checkDisabled(e);
                                }}
                                value={stroke}
                                checked={stroke} />}
                                label="Stroke / TIA" />
                        </div>
                    </Item>
                    {/* <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="TIA"
                                onChange={(e) => setTIA(e.target.checked)}
                                value={tIA}
                                checked={tIA} />} label="TIA" />
                        </div>
                    </Item> */}
                    <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="Diabetes"
                                onChange={(e) => {
                                    setDiabetes(e.target.checked);
                                }}
                                value={diabetes}
                                checked={diabetes} />}
                                label={<b>Diabetes mellitus</b>} />
                        </div>
                    </Item>
                    <Item>
                        <div align="left">
                            <FormControlLabel sx={{ minWidth: 225 }} control={<Checkbox id="ldlb"
                                onChange={(e) => setLdlb(e.target.checked)}
                                value={ldlb}
                                checked={ldlb} />}
                                label={<b>LDL >= 190 mg/dL</b>} />
                        </div>
                    </Item>
                </Grid>
                <Grid item xs={6} sm={4} md={4}>
                    <h3>ASCVD Risk score
                    </h3>
                    {/*<Item>*/}
                    {/*    <div align="left"><CustomizedDialogs/></div>*/}
                    {/*</Item>*/}
                    {/*<Item>*/}
                    {/*    <div align="right"><Button id="btnCalc"*/}
                    {/*                               onClick={() => console.log('Calc')}*/}
                    {/*                               variant="outlined">res</Button>*/}
                    {/*    </div>*/}
                    {/*</Item>*/}
                    <Item>
                        {/*<Typography variant="subtitle1" gutterBottom align="left">*/}
                        {/*    <br/>*/}
                        {/*    Result<br/>*/}
                        {/*    ---<br/>*/}
                        {/*    ---<br/>*/}
                        {/*    ---<br/>*/}
                        {/*    ---<br/>*/}
                        {/*    ASCVD:<br/>*/}
                        {/*    BMI:<br/>*/}
                        {/*</Typography>*/}
                        <Calculation
                            weight={weight}
                            height={height}
                            age={age}
                            sbp={sBP}
                            cholesterol={cholesterol}
                            hdl={hDL}
                            tg={tG}
                            sex={sex}
                            hypertension={hypertension}
                            cigarette={cigarette}
                            acvd={acvd}
                            pci={pCI}
                            asc={aCS}
                            aortic={aortic}
                            //mi={mI}
                            pad={pAD}
                            stroke={stroke}
                            // tia={tIA}
                            diabetes={diabetes}
                            ldlb={ldlb} />
                    </Item>
                    <Item>
                        <div align="left">
                            <a href='/tg.pdf'><h3>Hypertriglyceridemia Management</h3></a>
                        </div>
                        <div align="left">
                            <a href='/DrugDrugInteraction.pdf'><h3>Statin-Drug Interaction</h3></a>
                        </div>
                    </Item>
                </Grid>
            </Grid>
        </Box>
    );
}
export default MainPage;